// ------------------------------------
// props 輸入需求 : 
// props.hide : function( void )                    ( 開關按鈕 )
// props.pageName : array                           ( 傳進來的分頁名字 )
// ------------------------------------


import React, { useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Account from '../../actions/Account';
import ConfigHandler from '../../actions/ConfigHandler';
import { SET_PAGE, SET_PAGENAME } from '../../stores/reducer_HistoryPage';
import DropdownHis from './DropdownHis';
import { HisBarTabMobile } from './NavbarTabMobile';

const PopUpNavBarMobile =(props)=>{
    const is_PORL = window.innerHeight < window.innerWidth
    const {t} = useTranslation()
    const [menuPop, setMenuPop] = useState(0);
    function toggleMP(){ setMenuPop(!menuPop) }
    const pageNameArr = ConfigHandler.hisRecControl().layoutName
    const dropDownList = ConfigHandler.hisRecControl().dropDownList
    const pageIcon = ConfigHandler.hisRecControl().layoutImg
    const pageNum = ConfigHandler.hisRecControl().pageNum
    const [dropDownToggle, setDropDownToggle] = useState(Array(pageNum).fill(false));
    function toggleDropDown(index){
        let _row = Array(pageNum).fill(false)
        if(!index){setDropDownToggle(_row)}
        _row[index] = true
        setDropDownToggle(_row) 
    }
    const dispatch = useDispatch()
    useEffect(()=>{
        dispatch(SET_PAGENAME({pageNameList:pageNameArr, index:0}))
        return(()=>{
            dispatch(SET_PAGE(0))
        })
    }, [])
    const store = useSelector(state=>state.store_hisPage);
    if(Account.isMobile()){
        return<div className="h-15 fx-d-r font-m">
            <HisBarTabMobile show={menuPop} />
            <div className='h-100 fx-ccc'>
                <div className={`Hamburger ${menuPop ? 'barFrameClick':'barFrame'}`} onClick={toggleMP}>
                    <div className='nhambar'></div>
                </div>
            </div>
            <div className="w-60 fx-d-c fx-ccc">
                <div className="w-90 font-xl fx-fsc">{t(store.pageName)}</div>
                <div className="w-90 font-m fx-fsc">{t(dropDownList[store.page][store.dropDown])}</div>
            </div>
            {/* close btn */}
            <div className="w-15 " onClick={props.hide}>
                <div className={`cross ${is_PORL? '':'crossM'}  dark fx-ccc cursor pt"`}></div>
            </div>
            {/* close btn */}
        </div>
    }
    else{
        return(
            <div className="h-15 fx-d-r font-m">
                <div className="w-40 fx-d-c fx-ccc">
                    <div className="w-90 font-xl fx-fsc">{t(store.pageName)}</div>
                    <div className="w-90 font-m fx-fsc">{t(dropDownList[store.page][store.dropDown])}</div>
                </div>
                {is_PORL? <div className='w-30'></div>:null}
                {/* <div className='w-30'></div> */}
                {pageNameArr.map((name, index)=><div key={name} 
                    className={`fx-ccc his-option ${store.pageActive[index]? "activate":""} ${props.isShow[index]?'':'d-none'}`}
                    onClick={()=>{dispatch(SET_PAGE(index))}}
                    onMouseEnter={()=>{toggleDropDown(index)}}
                    onMouseLeave={()=>{toggleDropDown(false)}}>
                    <img className='img_crisp' src={pageIcon[index]} alt={pageNameArr[index]}/>
                    {t(name)}
                    {store.pageActive[index] && dropDownToggle[index]? 
                        <DropdownHis 
                            hide={toggleDropDown} 
                            data={{keys: dropDownList[index]}} 
                        />
                        :null
                    }
                    </div>)
                }
                {/* close btn */}
                <div className="fx-2 fx-nfen" onClick={props.hide}>
                    <div className={`cross ${is_PORL? '':'crossM'}  dark fx-ccc cursor pt"`}></div>
                </div>
                {/* close btn */}
            </div>
        );	
    }
}
export default PopUpNavBarMobile;